// extracted by mini-css-extract-plugin
module.exports = {"slideContent":"IntroSlide_slideContent__1WZXV","slideImage":"IntroSlide_slideImage__3JLJo"};